import * as AircraftLivery from './components/AircraftLivery.css';

export default {
	AircraftLivery
};
